export default __webpack_public_path__ + "cb261ef840d34dcd6e0f2db740fd9e2c.png";